export default __webpack_public_path__ + "static/media/Exaltate's Gloves.4141897a.jpg";